const riot = require('riot');

riot.tag2('module-messages', '<div class="s-full f flex-column flex-between overflow-hidden rounded-top-right-8"> <div class="f fm py6 px16 bg-white border-bottom s-mt18 s-pb0" if="{selectMode}" parent="{this}"> <div class="f w-full overflow-x-scroll"> <div class="p4 mr12 tooltip" aria-label="{isCheckedSome() ? &quot;全て外す&quot; : &quot;全て選択&quot;}" data-tooltip-position="top"> <input class="checkbox cursor-pointer" type="checkbox" onclick="{toggleCheckAll}" checked="{isCheckedSome()}" ref="parentCheckbox"> </div> <button class="button primary f fm py1 px6 border mr12 mr0-last" each="{button in selectActionButtons}" onclick="{button.action}"><i class="fs16 mr1 icon-{button.icon}"></i> <div class="fs12">{button.label}</div> </button> </div> <div class="fs13 flex-fixed text-label_dark_deep" if="{getSelectMessageCount()}"><span class="bold">{getSelectMessageCount()}</span><span>件選択中</span></div> <button class="button w24 p8" onclick="{disableSelectMode}"> <i class="icon-close fs24 text-label_dark_medium"></i></button> </div> <div class="overflow-hidden relative z0 h-full"> <div class="overflow-y-scroll h-full f flex-column-reverse bg-background_light_secondary" ref="body" onscroll="{onBodyScroll}"> <div each="{items,key in getSectionedMessages()}"> <div class="f fm w-full py10"> <div class="h1 w-full rounded-1 bg-separator_opacity"></div> <div class="font-lato bold fs11 text-label_dark_medium word-break-keep mx16">{key}</div> <div class="h1 w-full rounded-1 bg-separator_opacity"></div> </div> <div class="f flex-column-reverse"> <div each="{item in items}"> <div class="relative" if="{isUnread(item)}"> <div class="absolute trbl0 f fm"> <div class="h1 w-full bg-alert_primary"></div> </div> <div class="absolute tn8 r16 bg-alert_primary px6 rounded-4 font-lato fs10 text-white bold lh15">NEW</div> </div> <div data-is="item-message" parent="{this}" item="{item}" onreplyclick="{onReplyClick}" onquotereply="{onQuoteReply}" selectmode="{selectMode}" onmessageselect="{enableSelectMode}" note="{note}" project="{project}"></div> </div> </div> </div> </div> </div> <div class="flex-fixed max-height-600 min-height-110 border-top s-min-height-80" ref="form" data-is="module-comment-form" project="{project}" mentions="{formattedMentions}" note="{note}"></div> </div>', 'module-messages,[data-is="module-messages"]{display:block}', '', function(opts) {
    this.on('mount', () => {
      this.refs.form.on('commentpost', async({value}) => {

        this.refs.form.focusEditor();

        await app.api.child(`${this.note.ref.path}/messages`).post({
          content: value,
        });

        app.utils.storage.noteComment.delete(this.note.id);

        this.note.look();

        this.update();
        this.refs.body.scrollTop = 0;
      });

      this.refs.form.on('editorchange', _.throttle(() => {
        let comment = this.refs.form.getValue();
        app.utils.storage.noteComment.set(this.note.id, comment);
      }, 512));

      this.refs.body.onscroll = (e) => {
        let $elm = e.target;

        if ($elm.scrollTop >= 0) {
          this.debouncedLookNote();
          return ;
        }
        let max_scroll_value = $elm.scrollHeight - $elm.offsetHeight - 2;

        if (max_scroll_value <= 0) return ;

        if ($elm.scrollTop*-1 >= max_scroll_value) {
          this.debouncedFetchMore();
        }
      };

      this.refs.body.addEventListener('load', this.onLoadImg, true);

      this._handleMessagesKeydown = (e) => {
        const key = e.key || e.keyCode;
        const is_arrow_up = (typeof key === 'string' && key.toLowerCase() === 'arrowup') || key === 38 || e.code === 'ArrowUp';
        const is_arrow_down = (typeof key === 'string' && key.toLowerCase() === 'arrowdown') || key === 40 || e.code === 'ArrowDown';

        if (!app.useragent.isDesktop) return;
        if (this.selectMode) return;

        const editor_root = this.refs?.form?.refs?.editor?.root;
        const in_editor_focus = editor_root ? editor_root.contains(document.activeElement) : false;
        const is_empty = !this.refs.form.getValue().trim();

        if (is_arrow_up && in_editor_focus) {
          if (is_empty) {
            const items = this.getItems();
            const target = items.find(item => !item.isActivity() && !item.isMine());
            if (target) {
              e.preventDefault();
              this.onReplyClick(target);
              return;
            }
          }
        }

        if (is_arrow_down && in_editor_focus) {
          if (!is_empty) return ;
          const items = this.getItems();
          const target = items.find(item => !item.isActivity() && item.isMine());
          if (target) {
            e.preventDefault();
            const tags = this.getMessageTags().filter(Boolean);
            const tag = tags.find(t => t?.opts?.item?.id === target.id);
            if (tag && !tag.isEdit) {
              tag.onEdit();
              setTimeout(() => {
                tag.refs?.form?.focusEditor?.();
              }, 0);
            }
            return;
          }
        }
      };

      if (spat.isBrowser) {
        document.addEventListener('keydown', this._handleMessagesKeydown, true);
      }
    });

    this.on('unmount', () => {
      if (this._handleMessagesKeydown) {
        if (spat.isBrowser) {
          document.removeEventListener('keydown', this._handleMessagesKeydown, true);
        }

        this._handleMessagesKeydown = null;
      }
      this.refs?.body?.removeEventListener('load', this.onLoadImg, true);
    });

    this.selectActionButtons = [
      {label: '要約', icon: 'unread', action: () => this.openDifyPopup()},
      {label: 'コピー', icon: 'clip' , action: () => this.copySelectedMessages()},
    ];

    this.onLoadImg = (e) => {
      if (e.target.tagName !== 'IMG') return ;
      if (e.target.dataset.ignoreOnload === 'true') return ;
      this.fixScrollTop();
    };

    this.on('updated', () => {
      if (spat.isNode) return ;
      if (this.oldScrollTop != null && this.oldScrollTop < 0) return ;
      this.fixScrollTop();
    });

    this.fixScrollTop = () => {

      if (!this.root.offsetParent) return ;
      const scroll_top = this.refs.body.scrollTop;
      if (scroll_top >= 0) {

        this.refs.body.scrollTop -= 1;
        this.refs.body.scrollTop = scroll_top;
      }
    };

    this.onBodyScroll = () => {
      this.debouncedOnBodyScrollStopped();
    };

    this.debouncedOnBodyScrollStopped = _.debounce(() => {
      this.update();
    }, 64);

    this.setNote = async (note) => {
      this.note = note;
      this.update();

      if (this.observers) {
        this.observers.forEach(observer => {
          observer.unobserve();
        });
      }

      this.store = this.note.collection('messages').where('disabled', '==', false).orderBy('created_at', 'desc').limit(32);
      this.observers = [];

      await this.fetchMore();

      let inbox = this.note.getInbox();
      if (inbox) {

        let items = this.getItems();
        this.latestUnreadMessage = _.last(items.filter(item => !item.isActivity() && (item.data.created_at > inbox.data.last_message_read_at)));
      }
      else {

        this.latestUnreadMessage = null;
      }

      this.note.look();

      this.project = await this.note.getProject().fetch();

      this.mentions = await this.note.getProject().fetchMentions();
      this.formattedMentions = app.utils.formatMentions(this.mentions, this.note);
      this.update();

      this.refs.form.setOption('gutters', []);

      this.selectMode = false;

      let value = app.utils.storage.noteComment.get(this.note.id);
      this.refs.form.setValue(value);
    };

    this.getItems = () => {

      let items = _.flatten(this.observers.map(o => o.items));
      return items;
    };

    this.getSectionedMessages = () => {
      let items = this.getItems();

      let sections = _.groupBy(items, item => {
        return dayjs(item.data.created_at).format('YYYY/MM/DD(ddd)');
      });

      return sections;
    };

    this.onReplyClick = (item) => {
      let form = this.refs.form;
      let value = form.refs.editor.getValue();

      form.refs.editor.setValue(`${value}@${item.getUser().data.screen_name} `);
      form.refs.editor.focus();
      form.refs.editor.setCursorToLast();
    };

    this.onQuoteReply = (item) => {
      let form = this.refs.form;
      let value = form.refs.editor.getValue();

      let content = item.data.content.replace(/\n/g, '\n>');
      content = `${value}\n>${content}\n\n`;

      if (!item.isMine()) {
        let mention = `${value}@${item.getUser().data.screen_name} \n`;
        content = mention + content;
      }

      form.refs.editor.setValue(content);
      form.refs.editor.focus();
      form.refs.editor.setCursorToLast();
    };

    this.isUnread = (item) => {
      return this.latestUnreadMessage.id === item.id;
    };

    this.fetchMore = async () => {

      let lasted_observer = this.observers[this.observers.length-1];
      if (lasted_observer) {
        let lasted_item = lasted_observer.items[lasted_observer.items.length-1];
        if (lasted_item) {
          this.store.startAfter(lasted_item.doc);
        }
      }

      let note_id = this.note.id;
      let observer = this.store.observer(() => {
        this.update();

        observer.items.forEach(async item => {
          await item.relate();
          app.utils.debouncedUpdate();
        });
      });

      await observer.observe();

      if (this.note.id !== note_id) {
        return ;
      }

      this.oldScrollTop = this.refs.body.scrollTop;

      this.observers.push(observer);

      this.update();

      this.refs.body.scrollTop = this.oldScrollTop;
    };

    this.debouncedFetchMore = _.debounce(this.fetchMore, 128, true);

    this.focusEditor = () => {
      this.refs.form.focusEditor();
    };

    this.lookNote = () => {
      if (!this.note) return ;
      if (!this.note.isRead()) {
        return this.note.look();
      }
    };

    this.debouncedLookNote = _.debounce(this.lookNote, 256, true);

    this.selectMode = false;

    this.enableSelectMode = () => {
      this.selectMode = true;
      this.update();
    };

    this.disableSelectMode = () => {
      this.selectMode = false;
      this.update();
    };

    this.copySelectedMessages = async () => {
      let selected_tags = this.getSelectedMessageTags();

      const content = selected_tags.map(tag => tag.opts.item.data.content).join('\n');
      try {

        await navigator.clipboard.writeText(content);

        spat.toast.message('コピーしました');

        this.disableSelectMode();
      }
      catch (e) {
        console.error(e);

        spat.toast.message('コピー失敗しました');
      }
      this.update();
    };

    this.getMessageTags = () => {
      let message_tags = this.tags["item-message"];
      return Array.isArray(message_tags) ? message_tags : [message_tags];
    };

    this.getSelectedMessageTags =  () => {
      let message_tags = this.getMessageTags();

      let selected_tags = message_tags.filter((tag) => {
        return tag.refs.checkbox?.checked;
      });
      return selected_tags;
    };

    this.toggleCheckAll = (e) => {
      let is_checked = this.isCheckedSome();
      let message_tags = this.getMessageTags();

      message_tags.forEach(tag => {
        if (tag) {

          tag.trigger('update-checked', !is_checked);
        }
      });
      this.update();
    };

    this.isCheckedSome = () => {
      let message_tags = this.getMessageTags();
      return message_tags.some(tag => tag.refs.checkbox?.checked);
    };

    this.getSelectMessageCount = () => {
      let selected_tags = this.getSelectedMessageTags();
      return selected_tags.length;
    };

    this.openDifyPopup = () => {

      this.copySelectedMessages();

      const popup = spat.popup.open('popup-dify', {
        element: this.root,
        offsetTop: 20,
        position: 'top',
        opts: {
          description: '選択したメッセージをクリップボードにコピーしました。貼り付けて要約を作成しましょう。',
        }
      });
    };

    this.getElement = () => {
      return this.root;
    };

    this.getMessagesContainer = () => {
      return this.refs.body;
    };
});